import { call, put, takeLeading } from "redux-saga/effects";

import { postAPIPayload } from "../../../../apis/postApi";
import { adminDashboardAction } from "../../../slices/admin/admin-dashboard/adminDashboardSlice";

export function* fetchAdminDashboardDetailsSaga({ payload }) {
  console.log("in sagas--", payload);
  const response = yield call(postAPIPayload, payload);
  console.log("response==>.", response);
  yield put(adminDashboardAction.fetchAdminDashboardData(response));
}

export function* fetchEngagementMetricsSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(adminDashboardAction.fetchEngagementMetrics(response));
}

export function* fetchPostSubscriptionMetricsSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(adminDashboardAction.fetchPostSubscriptionMetrics(response));
}

export function* fetchPropertyProductionMetricsSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(adminDashboardAction.fetchPropertyProductionMetrics(response));
}

export function* fetchSubscriptionRevenueMetricsSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(adminDashboardAction.fetchSubscriptionRevenueMetrics(response));
}

export function* fetchCustomerExperienceMetricsSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(adminDashboardAction.fetchCustomerExperienceMetrics(response));
}

export function* watchAdminDashboardSagaAsync() {
  yield takeLeading(
    adminDashboardAction.getAdminDashboardData,
    fetchAdminDashboardDetailsSaga
  );
  yield takeLeading(
    adminDashboardAction.getEngagementMetrics,
    fetchEngagementMetricsSaga
  );
  yield takeLeading(
    adminDashboardAction.getPostSubscriptionMetrics,
    fetchPostSubscriptionMetricsSaga
  );
  yield takeLeading(
    adminDashboardAction.getPropertyProductionMetrics,
    fetchPropertyProductionMetricsSaga
  );
  yield takeLeading(
    adminDashboardAction.getSubscriptionRevenueMetrics,
    fetchSubscriptionRevenueMetricsSaga
  );
  yield takeLeading(
    adminDashboardAction.getCustomerExperienceMetrics,
    fetchCustomerExperienceMetricsSaga
  );
}
